'use strict';

import { decodeHtml, getVueTemplate } from '../../../_imports/utils/utils.common';
import MediaImage from '../../../vue/media-image.main.js';
import MediaVideoThumbnail from '../../../videos/media-video-thumbnail.main';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

const videoPlaylist = {
    template: getVueTemplate('resource-video-playlist'),
    components: {
        MediaImage,
        MediaVideoThumbnail,
        PerfectScrollbar
    },
    props: {
        playlist: Object,
        currentPageId: String,
        height: Number
    },
    data() {
        return {
            activeResourceVideoId: null,
            videoPlayerHeight: 0,
            perfectScrollBarElement: null,
            thumbnailLoadedCount: 0,
            isOpen: false,
            windowWidth: window.innerWidth
        }
    },
    computed: {
        isMobile() {
            return this.windowWidth <= 860;
        }
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.setWindowWidth);
            this.setWindowWidth();
        });
    },
    methods: {
        decodeHtml(html) {
            return decodeHtml(html);
        },
        thumbnailIsLoaded() {
            this.thumbnailLoadedCount++;

            if (this.thumbnailLoadedCount === this.playlist.resourceVideos.length) {
                if (this.$refs.ps) {
                    const thumbnailRef = this.$refs[`video-thumbnail-${this.currentPageId}`];
                    this.perfectScrollBarElement = this.$refs.ps.$el;
    
                    if (thumbnailRef
                        && thumbnailRef.length) {
                        const thumbnailElement = this.$refs[`video-thumbnail-${this.currentPageId}`][0];
                        const thumbnailElementTop = thumbnailElement.getBoundingClientRect().top - this.$refs.videoList.getBoundingClientRect().top;

                        const thumbnailElementHeight = thumbnailElement.getBoundingClientRect().height;
                        const perfectScrollbarHeight = this.perfectScrollBarElement.getBoundingClientRect().height;
                        const containerPaddingBottom = parseFloat(window.getComputedStyle(this.perfectScrollBarElement).getPropertyValue('padding-bottom'));

                        this.perfectScrollBarElement.scrollTop = thumbnailElementTop - perfectScrollbarHeight / 2 + thumbnailElementHeight / 2 + containerPaddingBottom;
                    }
                }
            }
        },
        toggleOpen() {
            if (this.isMobile) {
                this.isOpen = !this.isOpen;

                if (this.isOpen) {
                    setTimeout(() => {
                        this.setPlaylistHeightBasedOnElements();
                    }, 150);
                }
            }
        },
        canShowPlaylist() {
            if (this.isMobile) {
                return this.isOpen;
            }

            return true;
        },
        setWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        setPlaylistHeightBasedOnElements() {
            const psListElements = this.perfectScrollBarElement.querySelectorAll('li');
                
            if (psListElements.length) {
                const psListElementHeight = psListElements[0].getBoundingClientRect().height;
                let psListElementsToConsider = 5;

                if (psListElements.length < 5) {
                    psListElementsToConsider = psListElements.length;
                }

                const psNewHeight = psListElementsToConsider * psListElementHeight + psListElementsToConsider * 4 + 24;

                this.perfectScrollBarElement.style.height = `${psNewHeight}px`;
            }
        }
    },
    watch: {
        height(height) {
            setTimeout(() => {
                if (!this.isMobile) {
                    const titleHeight = 59;
    
                    if (height > titleHeight
                        && this.perfectScrollBarElement) {
                        this.perfectScrollBarElement.style.height = `${height - titleHeight}px`;
                    }
                } else {
                    this.setPlaylistHeightBasedOnElements();
                }
            }, 150);
        }
    }
};

export default videoPlaylist;